import React from 'react'
import CommitteeWorkgroupMappingForm from '../../features/CommitteeWorkgroupMappingForm/CommitteeWorkgroupMappingForm'

const CommitteeWorkgroupMapping = () => {
  return (
    <div>
      <CommitteeWorkgroupMappingForm />
    </div>
  )
}

export default CommitteeWorkgroupMapping
